import type { Token } from "@/domains/core"

export const defaultTokenSort = (a: Token, b: Token): number => {
  // First sort by usd value
  const usdValueComparison = Number(b.balanceUsdValue ?? 0) - Number(a.balanceUsdValue ?? 0)
  if (usdValueComparison !== 0) return usdValueComparison

  // then by token balance
  // const balanceComparison = Number(b?.balance ?? 0) - Number(a?.balance ?? 0)
  // if (balanceComparison !== 0) return balanceComparison

  // If balances are equal, sort by symbol
  return a.symbol.toLowerCase().localeCompare(b.symbol.toLowerCase())
}
